module.exports = __webpack_public_path__ + "img/channel-waybill.ca7f5954.svg";